var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoArakatu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logo_Arakatu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Arakatu",
    "data-name": "Logo Arakatu",
    clipPath: "url(#clip-Logo_Arakatu)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(-2491.755 -608.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M2502.077,717.915v3.438h.4v-1.3h.453a1.291,1.291,0,0,0,.91-.311,1.044,1.044,0,0,0,.336-.8.956.956,0,0,0-.3-.757,1.246,1.246,0,0,0-.854-.269Zm1.681,1.045a.678.678,0,0,1-.219.538.943.943,0,0,1-.636.19h-.422v-1.41h.472q.806,0,.806.681",
    transform: "translate(-4.188 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M2510.05,720.121a1.6,1.6,0,0,0-.114-.152.748.748,0,0,0-.121-.116.7.7,0,0,0-.149-.088v-.01a1.225,1.225,0,0,0,.316-.128.924.924,0,0,0,.239-.2.861.861,0,0,0,.154-.267.974.974,0,0,0,.053-.33.947.947,0,0,0-.079-.4.792.792,0,0,0-.219-.287.937.937,0,0,0-.331-.171,1.467,1.467,0,0,0-.416-.056h-1.026v3.438h.4V719.89h.331a.7.7,0,0,1,.2.027.553.553,0,0,1,.167.088.88.88,0,0,1,.152.155,2.223,2.223,0,0,1,.153.229l.575.964h.479l-.645-1.033c-.046-.075-.088-.141-.125-.2m-.465-.641a.835.835,0,0,1-.28.046h-.546v-1.247h.552a.768.768,0,0,1,.517.154.54.54,0,0,1,.178.43.7.7,0,0,1-.052.278.6.6,0,0,1-.146.208.65.65,0,0,1-.222.131",
    transform: "translate(-6.735 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M2517.741,719.551a1.794,1.794,0,0,0-.435-1.254,1.477,1.477,0,0,0-1.147-.48,1.568,1.568,0,0,0-1.221.494,1.9,1.9,0,0,0-.448,1.323,1.785,1.785,0,0,0,.44,1.254,1.509,1.509,0,0,0,1.171.482,1.536,1.536,0,0,0,1.194-.49,1.9,1.9,0,0,0,.446-1.33m-1.64,1.457a1.076,1.076,0,0,1-.859-.387,1.737,1.737,0,0,1,.008-2.048,1.109,1.109,0,0,1,.88-.391,1.087,1.087,0,0,1,.873.371,1.581,1.581,0,0,1,.316,1.053,1.511,1.511,0,0,1-.326,1.033,1.127,1.127,0,0,1-.892.369",
    transform: "translate(-9.224 -39.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M2523.471,721.353v-1.271l1.134-2.167h-.427l-.806,1.553a1.352,1.352,0,0,0-.091.21h-.007c-.047-.121-.075-.191-.084-.21l-.77-1.553h-.458l1.105,2.176v1.262Z",
    transform: "translate(-12.256 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M2529.271,719.785h1.242v-.362h-1.242v-1.144h1.343v-.364h-1.745v3.438h1.822v-.364h-1.42Z",
    transform: "translate(-15.058 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M2536.885,720.779a1.7,1.7,0,0,1-.9.229,1.168,1.168,0,0,1-.9-.373,1.417,1.417,0,0,1-.344-1,1.493,1.493,0,0,1,.368-1.057,1.251,1.251,0,0,1,.96-.4,1.642,1.642,0,0,1,.815.206v-.429a2.011,2.011,0,0,0-.81-.141,1.685,1.685,0,0,0-1.259.508,1.826,1.826,0,0,0-.5,1.333,1.746,1.746,0,0,0,.441,1.24,1.53,1.53,0,0,0,1.175.472,2.015,2.015,0,0,0,.949-.2Z",
    transform: "translate(-17.269 -39.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M2542.267,721.353v-3.073h.992v-.365h-2.385v.365h.99v3.073Z",
    transform: "translate(-19.928 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M2547.145,718.312a1.894,1.894,0,0,0-.448,1.323,1.785,1.785,0,0,0,.441,1.254,1.509,1.509,0,0,0,1.17.482,1.534,1.534,0,0,0,1.194-.49,1.9,1.9,0,0,0,.446-1.33,1.8,1.8,0,0,0-.435-1.254,1.478,1.478,0,0,0-1.148-.48,1.566,1.566,0,0,0-1.22.494m2.381,1.3a1.512,1.512,0,0,1-.326,1.033,1.127,1.127,0,0,1-.892.369,1.074,1.074,0,0,1-.859-.387,1.738,1.738,0,0,1,.008-2.048,1.108,1.108,0,0,1,.879-.39,1.084,1.084,0,0,1,.873.371,1.576,1.576,0,0,1,.317,1.053",
    transform: "translate(-22.29 -39.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M2556.5,719.834a1.581,1.581,0,0,0-.29-.223q-.166-.1-.35-.193c-.12-.059-.226-.112-.318-.163a1.333,1.333,0,0,1-.233-.153.544.544,0,0,1-.145-.175.491.491,0,0,1-.049-.228.422.422,0,0,1,.064-.239.523.523,0,0,1,.167-.161.733.733,0,0,1,.236-.09,1.274,1.274,0,0,1,.263-.028,1.34,1.34,0,0,1,.782.212v-.453a1.68,1.68,0,0,0-.741-.122,1.74,1.74,0,0,0-.437.055,1.231,1.231,0,0,0-.383.168.9.9,0,0,0-.271.286.875.875,0,0,0-.037.744.857.857,0,0,0,.182.256,1.454,1.454,0,0,0,.27.206q.156.094.336.184c.114.058.219.112.318.164a1.663,1.663,0,0,1,.255.164.673.673,0,0,1,.169.188.516.516,0,0,1-.122.638.919.919,0,0,1-.555.138,1.421,1.421,0,0,1-.235-.021,1.944,1.944,0,0,1-.253-.061,1.686,1.686,0,0,1-.239-.1.935.935,0,0,1-.2-.13v.475a.725.725,0,0,0,.178.082,2.032,2.032,0,0,0,.236.063c.083.017.165.03.244.038a1.876,1.876,0,0,0,.2.014,2.143,2.143,0,0,0,.465-.049,1.166,1.166,0,0,0,.389-.159.821.821,0,0,0,.268-.286.864.864,0,0,0,.1-.431.759.759,0,0,0-.073-.34,1,1,0,0,0-.2-.271",
    transform: "translate(-25.532 -39.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17187",
    "data-name": "Rectangle 17187",
    width: 0.402,
    height: 3.438,
    transform: "translate(2535.232 678.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M2569.273,718.613l1.77,2.74h.494v-3.438h-.4v2.421a3.706,3.706,0,0,0,.024.506h-.01c-.021-.042-.067-.118-.139-.231l-1.721-2.7h-.522v3.438h.4v-2.484a3.43,3.43,0,0,0-.019-.472h.015a1.127,1.127,0,0,0,.11.216",
    transform: "translate(-31.244 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M2578.521,720.3q-.062.139-.165.422h-.014a3.2,3.2,0,0,0-.159-.412l-1.055-2.4h-.532v3.438h.388v-2.3q0-.467-.019-.674h.01a2.047,2.047,0,0,0,.1.353l1.172,2.622h.2l1.174-2.642a2.171,2.171,0,0,0,.1-.334h.01c-.022.265-.033.487-.033.67v2.306h.4v-3.438h-.5Z",
    transform: "translate(-34.421 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M2585.736,718.312a1.89,1.89,0,0,0-.448,1.323,1.79,1.79,0,0,0,.439,1.254,1.512,1.512,0,0,0,1.172.482,1.535,1.535,0,0,0,1.194-.49,1.9,1.9,0,0,0,.446-1.33,1.794,1.794,0,0,0-.435-1.254,1.477,1.477,0,0,0-1.146-.48,1.565,1.565,0,0,0-1.22.494m2.38,1.3a1.513,1.513,0,0,1-.326,1.033,1.127,1.127,0,0,1-.892.369,1.075,1.075,0,0,1-.86-.387,1.738,1.738,0,0,1,.008-2.048,1.109,1.109,0,0,1,.88-.39,1.087,1.087,0,0,1,.873.371,1.578,1.578,0,0,1,.316,1.053",
    transform: "translate(-37.947 -39.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M2595.336,719.21a.834.834,0,0,0,.158-.509.7.7,0,0,0-.261-.568,1.072,1.072,0,0,0-.707-.218h-.978v3.437h1a1.176,1.176,0,0,0,.8-.273.9.9,0,0,0,.317-.714.807.807,0,0,0-.208-.576.876.876,0,0,0-.556-.263v-.01a.854.854,0,0,0,.436-.307m-.093,1.151a.575.575,0,0,1-.2.46.818.818,0,0,1-.551.168h-.547v-1.237h.463q.83,0,.829.609m-.36-1.13a.779.779,0,0,1-.52.159h-.412v-1.11h.463c.439,0,.659.167.659.5a.555.555,0,0,1-.19.449",
    transform: "translate(-41.298 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17188",
    "data-name": "Rectangle 17188",
    width: 0.403,
    height: 3.438,
    transform: "translate(2556.046 678.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M2605.571,720.989h-1.381v-3.074h-.4v3.438h1.784Z",
    transform: "translate(-45.452 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17189",
    "data-name": "Rectangle 17189",
    width: 0.403,
    height: 3.438,
    transform: "translate(2561.627 678.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M2612.509,721.353h.448l.344-.964h1.457l.365.964h.446l-1.323-3.438h-.417Zm1.515-3.021h.01a1.455,1.455,0,0,0,.053.231l.54,1.465h-1.192l.535-1.465a1.256,1.256,0,0,0,.054-.231",
    transform: "translate(-48.991 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M2621.854,720.121a1.6,1.6,0,0,0-.114-.152.811.811,0,0,0-.121-.116.71.71,0,0,0-.15-.088v-.01a1.214,1.214,0,0,0,.315-.128.909.909,0,0,0,.24-.2.851.851,0,0,0,.154-.267.974.974,0,0,0,.054-.33.944.944,0,0,0-.079-.4.792.792,0,0,0-.219-.287.94.94,0,0,0-.331-.171,1.463,1.463,0,0,0-.416-.056h-1.026v3.438h.4V719.89h.331a.684.684,0,0,1,.2.027.555.555,0,0,1,.168.088.844.844,0,0,1,.151.155,2.072,2.072,0,0,1,.154.229l.575.964h.479l-.645-1.033c-.046-.075-.088-.141-.125-.2m-.466-.641a.832.832,0,0,1-.279.046h-.546v-1.247h.551a.768.768,0,0,1,.517.154.54.54,0,0,1,.178.43.712.712,0,0,1-.053.278.6.6,0,0,1-.146.208.647.647,0,0,1-.222.131",
    transform: "translate(-52.095 -39.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17190",
    "data-name": "Rectangle 17190",
    width: 0.403,
    height: 3.438,
    transform: "translate(2571.983 678.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M2630.674,718.312a1.893,1.893,0,0,0-.448,1.323,1.785,1.785,0,0,0,.44,1.254,1.509,1.509,0,0,0,1.171.482,1.535,1.535,0,0,0,1.194-.49,1.9,1.9,0,0,0,.446-1.33,1.8,1.8,0,0,0-.435-1.254,1.479,1.479,0,0,0-1.148-.48,1.565,1.565,0,0,0-1.22.494m2.38,1.3a1.511,1.511,0,0,1-.326,1.033,1.127,1.127,0,0,1-.892.369,1.076,1.076,0,0,1-.86-.387,1.737,1.737,0,0,1,.009-2.048,1.108,1.108,0,0,1,.879-.39,1.085,1.085,0,0,1,.873.371,1.577,1.577,0,0,1,.316,1.053",
    transform: "translate(-56.179 -39.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M2640.027,719.834a1.523,1.523,0,0,0-.29-.223c-.109-.067-.227-.131-.349-.193s-.226-.112-.318-.163a1.353,1.353,0,0,1-.234-.153.548.548,0,0,1-.144-.175.494.494,0,0,1-.05-.228.419.419,0,0,1,.065-.239.513.513,0,0,1,.167-.161.736.736,0,0,1,.236-.09,1.268,1.268,0,0,1,.263-.028,1.335,1.335,0,0,1,.781.212v-.453a1.676,1.676,0,0,0-.741-.122,1.739,1.739,0,0,0-.437.055,1.229,1.229,0,0,0-.383.168.888.888,0,0,0-.271.286.87.87,0,0,0-.037.744.863.863,0,0,0,.181.256,1.473,1.473,0,0,0,.271.206q.156.094.336.184l.318.164a1.7,1.7,0,0,1,.255.164.68.68,0,0,1,.169.188.514.514,0,0,1-.122.638.918.918,0,0,1-.555.138,1.415,1.415,0,0,1-.235-.021,1.873,1.873,0,0,1-.253-.061,1.638,1.638,0,0,1-.24-.1.948.948,0,0,1-.2-.13v.475a.725.725,0,0,0,.179.082,1.99,1.99,0,0,0,.236.063c.082.017.164.03.244.038a1.876,1.876,0,0,0,.2.014,2.135,2.135,0,0,0,.465-.049,1.157,1.157,0,0,0,.389-.159.826.826,0,0,0,.269-.286.861.861,0,0,0,.1-.431.759.759,0,0,0-.073-.34.993.993,0,0,0-.2-.271",
    transform: "translate(-59.42 -39.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M2496.221,728.192l-4.467,11.645h1.519l1.161-3.264h4.938l1.235,3.264h1.51l-4.483-11.645Zm-1.332,7.155,1.811-4.962a4.335,4.335,0,0,0,.187-.779h.033a4.773,4.773,0,0,0,.178.779l1.827,4.962Z",
    transform: "translate(0 -43.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M2523.409,735.667a5.418,5.418,0,0,0-.386-.516,2.874,2.874,0,0,0-.41-.394,2.476,2.476,0,0,0-.508-.3v-.033a4.124,4.124,0,0,0,1.068-.434,3.131,3.131,0,0,0,.813-.678,2.923,2.923,0,0,0,.52-.905,3.287,3.287,0,0,0,.183-1.117,3.216,3.216,0,0,0-.268-1.36,2.705,2.705,0,0,0-.743-.971,3.159,3.159,0,0,0-1.121-.581,4.96,4.96,0,0,0-1.409-.191h-3.475v11.645h1.364v-4.954h1.121a2.335,2.335,0,0,1,.687.094,1.779,1.779,0,0,1,.568.3,2.933,2.933,0,0,1,.516.524,7.08,7.08,0,0,1,.519.776l1.95,3.264h1.624l-2.185-3.5q-.235-.382-.426-.67m-1.575-2.172a2.812,2.812,0,0,1-.946.155h-1.852v-4.223h1.868a2.6,2.6,0,0,1,1.75.524,1.829,1.829,0,0,1,.6,1.458,2.355,2.355,0,0,1-.179.938,2,2,0,0,1-.495.707,2.19,2.19,0,0,1-.751.443",
    transform: "translate(-10.515 -43.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M2542.206,728.192l-4.466,11.645h1.519l1.161-3.264h4.938l1.234,3.264h1.51l-4.482-11.645Zm-1.332,7.155,1.811-4.962a4.369,4.369,0,0,0,.187-.779h.032a4.736,4.736,0,0,0,.179.779l1.827,4.962Z",
    transform: "translate(-18.656 -43.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M2571.411,728.192h-1.7l-4.352,5.075a3.174,3.174,0,0,0-.309.4h-.032v-5.473h-1.365v11.645h1.365V734.1h.032a3.28,3.28,0,0,0,.309.406l4.5,5.327h1.9l-5.344-6.058Z",
    transform: "translate(-29.171 -43.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M2587.685,728.192l-4.466,11.645h1.518l1.162-3.264h4.937l1.234,3.264h1.511l-4.483-11.645Zm-1.332,7.155,1.812-4.962a4.338,4.338,0,0,0,.186-.779h.032a4.757,4.757,0,0,0,.179.779l1.827,4.962Z",
    transform: "translate(-37.108 -43.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M2605.118,729.426h3.354v10.411h1.364V729.426h3.362v-1.234h-8.081Z",
    transform: "translate(-45.992 -43.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M2634.44,735.347q0,3.46-2.916,3.459-3.021,0-3.021-3.582v-7.032h-1.365v7.122q0,4.718,4.239,4.718,4.426,0,4.427-4.905v-6.935h-1.365Z",
    transform: "translate(-54.926 -43.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M2645.772,744.278a1.547,1.547,0,0,0-.281-.216q-.16-.1-.338-.186c-.117-.058-.219-.11-.308-.158a1.423,1.423,0,0,1-.226-.149.534.534,0,0,1-.14-.169.483.483,0,0,1-.047-.221.416.416,0,0,1,.063-.232.483.483,0,0,1,.163-.155.7.7,0,0,1,.227-.087,1.259,1.259,0,0,1,.256-.026,1.3,1.3,0,0,1,.757.2v-.439a1.631,1.631,0,0,0-.717-.118,1.717,1.717,0,0,0-.424.054,1.2,1.2,0,0,0-.371.163.845.845,0,0,0-.262.278.845.845,0,0,0-.036.72.847.847,0,0,0,.175.247,1.412,1.412,0,0,0,.262.2c.1.06.209.12.325.178s.212.109.308.159a1.594,1.594,0,0,1,.247.158.648.648,0,0,1,.164.183.5.5,0,0,1-.118.618.889.889,0,0,1-.538.134,1.409,1.409,0,0,1-.228-.021,1.8,1.8,0,0,1-.244-.059,1.567,1.567,0,0,1-.233-.094.92.92,0,0,1-.189-.125v.46a.716.716,0,0,0,.173.08,2.087,2.087,0,0,0,.229.06c.08.016.159.029.237.037a1.76,1.76,0,0,0,.195.013,2.033,2.033,0,0,0,.45-.048,1.128,1.128,0,0,0,.378-.154.783.783,0,0,0,.26-.277.837.837,0,0,0,.1-.417.744.744,0,0,0-.071-.33.974.974,0,0,0-.191-.262",
    transform: "translate(-61.774 -49.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M2650.757,742.42l-1.277,3.329h.435l.332-.933h1.411l.353.933h.431l-1.281-3.329Zm-.381,2.045.518-1.419a1.267,1.267,0,0,0,.053-.223h.009a1.361,1.361,0,0,0,.051.223l.522,1.419Z",
    transform: "translate(-63.99 -49.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M2658.574,744.54a.959.959,0,0,0-.191-.262,1.574,1.574,0,0,0-.281-.216q-.161-.1-.339-.186c-.116-.058-.219-.109-.308-.158a1.412,1.412,0,0,1-.226-.149.519.519,0,0,1-.14-.169.472.472,0,0,1-.048-.22.414.414,0,0,1,.063-.232.5.5,0,0,1,.163-.155.722.722,0,0,1,.228-.087,1.247,1.247,0,0,1,.256-.026,1.3,1.3,0,0,1,.757.2v-.439a1.636,1.636,0,0,0-.718-.118,1.691,1.691,0,0,0-.424.054,1.191,1.191,0,0,0-.37.163.855.855,0,0,0-.262.277.841.841,0,0,0-.036.72.839.839,0,0,0,.175.247,1.437,1.437,0,0,0,.262.2c.1.06.208.12.325.178l.307.159a1.637,1.637,0,0,1,.248.158.668.668,0,0,1,.164.183.5.5,0,0,1-.118.619.9.9,0,0,1-.538.133,1.4,1.4,0,0,1-.228-.021,1.784,1.784,0,0,1-.245-.059,1.515,1.515,0,0,1-.233-.094.922.922,0,0,1-.189-.125v.46a.7.7,0,0,0,.173.08,1.954,1.954,0,0,0,.229.06c.08.016.159.029.237.037a1.757,1.757,0,0,0,.2.013,2.038,2.038,0,0,0,.45-.048,1.128,1.128,0,0,0,.377-.154.787.787,0,0,0,.26-.278.838.838,0,0,0,.1-.417.744.744,0,0,0-.071-.33",
    transform: "translate(-66.89 -49.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M2629.726,666.558l-13.883-30.116-3.024-.63,13.332,30.36Z",
    transform: "translate(-49.117 -6.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M2621.049,687.566l-.367.276-20.237,15.22,2.573.085,21.468-15.211Z",
    transform: "translate(-44.097 -27.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M2597.221,678.317l1.431,3.691,20.784-15.631-9.653-21.984-3.68-8.381-3.283,4.332,10.307,25.467Z",
    transform: "translate(-42.789 -6.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M2609.1,663.616l.068.007,3.32.323-12.617-31.2-2.857-.6,8.291,21.581Z",
    transform: "translate(-42.704 -4.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M2605.59,685.955l-1.989-.194-19.949,16.619,2.442.036,20.766-16.338Z",
    transform: "translate(-37.283 -26.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M2592.425,639.022l-2.54-6.61-3.494,4.992,10.122,25.716-16.152,12.987,1.507,4.478,20.094-16.739Z",
    transform: "translate(-35.948 -4.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M2592.058,660.138l3.125.3.443.042-13.085-33.26-3.013-.628,6.945,18.6Z",
    transform: "translate(-35.61 -2.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M2586.15,683.708l-20.99,17.846,2.589.029,21.843-17.548Z",
    transform: "translate(-29.781 -25.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M2584.61,660.374l-7.843-21-4.674-12.515-4.45,6.461,9.66,18.476-15.19,22.351,1.369,4.191Z",
    transform: "translate(-28.545 -2.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M2572.481,649.254l1.827.228-14.059-26.9-4.078-.8,14.169,27.2Z",
    transform: "translate(-26.134 -0.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M2546.815,671.729l1.7,4.611,17.669-27.044-14.159-27.182-1.656,3.956,10.441,15.883Z",
    transform: "translate(-22.338 -0.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M2571.895,668.732l-1.81-.226-2.192-.273-17.681,27.062,3.61.01Z",
    transform: "translate(-23.716 -19.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M2555.8,640.537l2.5.4-13.09-19.921-2.944-.763,11.679,19.981Z",
    transform: "translate(-20.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M2551.448,654.563l-10.965,25.159-4.369,10.024,3.629.014,16.187-34.474Z",
    transform: "translate(-17.997 -13.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M2549.678,640.558l-11.689-20-2.11,6.852,5.2,4.79-8.468,35.932,1.831,7.391Z",
    transform: "translate(-16.574 -0.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M2502.113,658.574l6.3-26.835-10.088-10.6-6.116,32.834,5.913,21.61Z",
    transform: "translate(-0.183 -0.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M2517.415,639.751l-4.407-.507-10.4,44.3,4.532-.048Z",
    transform: "translate(-4.404 -7.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M2535.89,640.177l-4.526-.534-10.37,44.063,4.651-.02Z",
    transform: "translate(-11.863 -7.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M2515.372,665.059l3.068,10.689.379-1.611,9.889-42.017-5.869-6-4.535-4.633-1,5.374,5.747,5.441Z",
    transform: "translate(-9.582 -0.501)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArakatu);
export default __webpack_public_path__ + "static/media/LOGO-ARAKATU.23f95bdc6f03d0010f5dc67a4fed875f.svg";
export { ForwardRef as ReactComponent };